module.exports = __webpack_public_path__ + "static/media/hk.232e86e1.svg";